<template>
  <div>
    <Header
      v-if="
        !this.$store.getters.iframeColidee
      "
      :window="window"
      :parameters="'adminPage'"
    />
    <div
      :class="
        !this.$store.getters.iframeColidee
          ? window.width < 480
            ? 'container-fluid'
            : 'container mt-1 mb-3'
          : ''
      "
    >
      <ButtonReturnColidee
        v-if="
         this.$store.getters.iframeColidee && adminActiveComponents.parameters
        "
        :adminComponent="true"
      />
      <SearchBar v-if="adminActiveComponents.searchBar" />
      <CardsList style="background:#fff" class="card" :window="window" v-if="adminActiveComponents.cardList" />
      <br />
      <Parameters style="background:#fff" class="card" v-if="adminActiveComponents.parameters" />
    </div>
    <MyFooter
      v-if="
        !this.$store.getters.iframeColidee
      "
      :window="window"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/layout/Header'
import MyFooter from '@/components/layout/MyFooter'
import CardsList from '@/components/sondage/CardsList'
import Parameters from '@/components/sondage/Parameters'
import SearchBar from '@/components/sondage/components/SearchBar'
import ButtonReturnColidee from '@/components/button/ButtonReturnColidee'
export default {
  name: 'Admin',
  components: {
    Header,
    MyFooter,
    CardsList,
    Parameters,
    SearchBar,
    ButtonReturnColidee
  },
  data () {
    return {
      window: {
        width: document.body.scrollHeight
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  mounted () {
    this.$nextTick(() => {
      this.handleResize()
    })
  },
  computed: {
    ...mapGetters(['adminActiveComponents'])
  },
  updated () {
    this.sendMessageToParent('scrollToTop')
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    sendMessageToParent (taskToDo) {
      let message = {
        task: taskToDo
      }
      window.top.postMessage(message, '*')
    },
    handleResize () {
      let message = {
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
      this.window.width = window.innerWidth
    }
  }
}
</script>
<style scoped>
.white_space_200{
  height:200px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Admin.vue